import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../../axios";
import styles from "./CouponCode.module.css";
import { R_PER_PAGE } from "../../../../../labels";
import Loader from "../../../Loader";
import moment from "moment";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";

export default function ViewCouponCode() {
  const { id } = useParams();
  const location = useLocation();
  const { STATUS, SEARCH } = location.state;
  let page = R_PER_PAGE;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [formFields, setFormFields] = useState({
    title: "",
    coupon_code: "",
    batch_name: "",
    amount: "",
    start_date: "",
    end_date: "",
    emailIds: "",
    emailLabel: [],
    newEmails: [],
    applicable_users: [],
  });
  const [applyUser, setApplyUser] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmations, setShowConfirmations] = useState(false);
  const openModal = () => setShowConfirmations(true);
  const closeModal = () => setShowConfirmations(false);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/all/coupon/findbyId", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setFormFields({
            title: res.data.coupon_data[0].title,
            coupon_code: res.data.coupon_data[0].coupon_code,
            amount: res.data.coupon_data[0].amount,
            start_date: res.data.coupon_data[0].start_date,
            end_date: res.data.coupon_data[0].end_date,
            batch_name: res.data.coupon_data[0].batch_name,
          });
          const fiata = res.data.applicable_users;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setApplyUser(serialNumberAddedData);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);
  const navigateToPreviousScreen = () => {
    navigate("/ListCouponCode", {
      state: {
        filter_status: STATUS,
        filter_search: SEARCH,
      },
    });
  };
  const handleNavigate = (idsss) => {
    navigate(`/editCoupon/${idsss}`);
  };

  useEffect(() => {
    setApplyUser(applyUser);
  }, [applyUser]);

  // total table data  with pages
  const totalPages = Math.ceil(applyUser?.length / rowsPerPage);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    // setApplyUser([]);
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);
  const currentData = applyUser?.slice(start, end);
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = applyUser.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setApplyUser(sortedList);
    // setSortColumn(sortKey);
  };
  const isDisabled =
    applyUser.length > 0 &&
    applyUser.some((item) => item.is_applied == 0 || item.is_applied == 2);

  const handleDelete = () => {
    const updateCoupon = {
      id: id,
      is_deleted: 1,
      coupon_title: null,
      amount: null,
      start_date: null,
      end_date: null,
      created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_by: "",
      batch_status: null,
      batch_selection: null,
      users: null,
      batch_id: null,
    };

    AxiosInstance.post(`api/all/coupon/add`, updateCoupon)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message || "Coupon deleted successfully.");
          closeModal();
          navigate("/ListCouponCode");
        } else {
          toast.error(res.data.message || "Failed to delete coupon.");
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Something went wrong while deleting the coupon.");
      });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showConfirmations && (
        <Modal show={showConfirmations} onHide={closeModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 className="ModalHeader mb-0">Delete Coupon Code</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-4 col-md-7">
              <p className="text-start" style={{ minHeight: "100px" }}>
                Are you sure you want to delete this Coupon Code?
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end w-100">
              <button
                className={`${styles.dont_delete} bg-white secondaryButton border-0 mx-2`}
                onClick={closeModal}
              >
                No, Keep It
              </button>
              <button
                className="primaryButton border-0 mx-2"
                onClick={handleDelete}
              >
                Yes, Delete
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      <div className={`${styles.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Coupon Code</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  onClick={navigateToPreviousScreen}
                  to="javascript:void(0)"
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to Coupon Codes
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={isDisabled ? undefined : () => openModal()}
                  className={`primaryButton ${isDisabled ? "disabledbtn" : ""}`}
                  disabled={isDisabled}
                  variant="primary"
                >
                  Delete Coupon Code
                </Link>
              </li>
              <li class="ListBtnItems">
                {/* {isDisabled === false && ( */}
                <Link
                  to="javascript:void(0)"
                  onClick={isDisabled ? undefined : () => handleNavigate(id)}
                  className={`primaryButton ${isDisabled ? "disabledbtn" : ""}`}
                  disabled={isDisabled}
                  variant="primary"
                >
                  {" "}
                  <span
                    className={` ${
                      isDisabled ? "disabledbtn" : ""
                    } material-icons me-1 fs-5 align-middle text-white `}
                  >
                    border_color
                  </span>{" "}
                  Edit Coupon Code
                </Link>

                {/* )} */}
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Coupon Code Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Title</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.title || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Coupon Code</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.coupon_code || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Amount</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.amount || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Batch Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.batch_name || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Valid From</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {`${moment(formFields.start_date).format("DD/MM/YYYY")}`}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Valid To</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {`${moment(formFields.end_date).format("DD/MM/YYYY")}`}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <fieldset className="mt-3">
          <legend className="w-auto">Applicable Students</legend>
          <div className="row mt-2 mx-0">
            <div className="col-md-12 table-responsive tableMinHeight px-0">
              <table className="table" id="tableListHeader">
                <thead>
                  <tr>
                    {/* S.No. */}
                    <th id="th">
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "serialNumber")}
                      >
                        S.No
                      </span>
                      <span
                        className={`textHead_th material-icons align-middle`}
                        onClick={(e) => handleSort(e, "serialNumber")}
                      >
                        import_export{" "}
                      </span>
                    </th>
                    <th id="th">
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "name")}
                      >
                        {" "}
                        Student Name
                      </span>
                      <span
                        className={`material-icons textHead_th align-middle`}
                        onClick={(e) => handleSort(e, "name")}
                      >
                        import_export
                      </span>{" "}
                    </th>
                    {/* Course */}
                    <th id="th">
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "email")}
                      >
                        {" "}
                        Email Ids
                      </span>
                      <span
                        className={`material-icons textHead_th align-middle`}
                        onClick={(e) => handleSort(e, "email")}
                      >
                        import_export
                      </span>{" "}
                    </th>
                    <th id="th">
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "applied_source")}
                      >
                        {" "}
                        Applied For
                      </span>
                      <span
                        className={`material-icons textHead_th align-middle`}
                        onClick={(e) => handleSort(e, "applied_source")}
                      >
                        import_export
                      </span>{" "}
                    </th>
                    <th id="th">
                      <span
                        className="textHead_th"
                        onClick={(e) => handleSort(e, "is_applied")}
                      >
                        {" "}
                        Status
                      </span>
                      <span
                        className={`material-icons textHead_th align-middle`}
                        onClick={(e) => handleSort(e, "is_applied")}
                      >
                        import_export
                      </span>{" "}
                    </th>

                    {/* <th id="th">
                                    <span
                                        className="textHead_th"
                                        onClick={(e) => handleSort(e, "course_name")}
                                    >
                                        {" "}
                                        Not Yet Applied
                                    </span>
                                    <span
                                        className={`material-icons textHead_th align-middle`}
                                        onClick={(e) => handleSort(e, "course_name")}
                                    >
                                        import_export
                                    </span>{" "}
                                </th> */}
                  </tr>
                </thead>
                <tbody>
                  {currentData?.length === 0 ? (
                    <tr>
                      <td
                        colSpan="15"
                        style={{
                          textAlign: "center",
                          borderBottom: "1px solid #dee2e6",
                        }}
                      >
                        No records to display
                      </td>
                    </tr>
                  ) : (
                    currentData?.map((course, index) => (
                      <tr key={index}>
                        <td id="td">{course.serialNumber}</td>
                        <td id={`${styles.td}tabTh`}>
                          <span
                            className={`${styles.ellipsis}`}
                            title={course.name}
                          >
                            {course.name}
                          </span>
                        </td>
                        <td id={`${styles.td}tabTh`}>
                          <span
                            className={`${styles.ellipsis}`}
                            title={course.email}
                          >
                            {course.email}
                          </span>
                        </td>
                        <td id={`${styles.td}tabTh`}>
                          <span
                            className={`${styles.ellipsis}`}
                            title={course.applied_source}
                          >
                            {course.applied_source}
                          </span>
                        </td>
                        {course.is_applied == 0 && (
                          <td id={`${styles.td}`}>
                            <span class="filterChipText bg-green mx-0 ">
                              Applied
                            </span>
                          </td>
                        )}
                        {course.is_applied == 1 && (
                          <td id={`${styles.td}`}>
                            <span class="filterChipText bg-orange mx-0">
                              Not Yet Applied
                            </span>
                          </td>
                        )}
                        {course.is_applied == 2 && (
                          <td id={`${styles.td}`}>
                            <span class="filterChipText bg-danger mx-0 ">
                              Expired
                            </span>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row mt-2">
            <Pagination
              rowsPerPage={rowsPerPage}
              handlePageCount={handlePageCount}
              startPage={
                applyUser && applyUser?.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0
              }
              // endPage={
              //     applyUser && applyUser?.length > 0
              //         ? applyUser?.length < currentPage * rowsPerPage
              //             ? applyUser?.length
              //             : currentPage * rowsPerPage
              //         : 0
              // }
              endPage={
                applyUser && applyUser?.length > 0
                  ? Math.min(applyUser?.length, currentPage * rowsPerPage)
                  : 0
              }
              totalRecords={
                applyUser && applyUser?.length > 0 ? applyUser?.length : 0
              }
              handlePrev={(e) => handlePrev(currentPage - 1)}
              currentPrevPage={currentPage === 1}
              prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
              handleNext={() => handleNext(currentPage + 1)}
              currentNextPage={currentPage === totalPages || totalPages == 0}
            />
          </div>
        </fieldset>
      </div>
    </>
  );
}
